import BrevetMediaIcon from "../../icons/brevetScreen/BrevetMediaIcon";
import {kSystemIcons} from "../../../constants/icons";

export default function BrevetLevelAMediaList({levelA}) {
    // Used in

    // BUILD
    return (
        <div className={"flex justify-start items-center space-x-[6px]"}>
            <BrevetMediaIcon hasMedia={true}
                             icon={kSystemIcons.bolt}
                             tooltip={"Flash"} />
            <BrevetMediaIcon hasMedia={false}
                             icon={kSystemIcons.exam}
                             tooltip={"Fiche"} />
            <BrevetMediaIcon hasMedia={false}
                             icon={kSystemIcons.video}
                             tooltip={"Vidéo"} />
            <BrevetMediaIcon hasMedia={false}
                             icon={kSystemIcons.calculation}
                             tooltip={"Exerciseur"} />
        </div>
    );
}